import { render, staticRenderFns } from "./WorkContractsPanel.vue?vue&type=template&id=2084afe8&scoped=true"
import script from "./WorkContractsPanel.vue?vue&type=script&lang=js"
export * from "./WorkContractsPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkContractsPanel.vue?vue&type=style&index=0&id=2084afe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084afe8",
  null
  
)

export default component.exports